import React from 'react';
import Marquee from 'react-fast-marquee';
import { useIsBreakpointDown, useIsBreakpointUp } from '@soluto-design/react';
import cls from '@soluto-design/styles/cls';

export interface BandLogosSectionProps {
    logos: string[];
}

export default function BandLogosSection({ logos }: BandLogosSectionProps) {
    const isMobile = useIsBreakpointDown('xs');
    const isMd = useIsBreakpointUp('md');

    const play = (isMobile && logos?.length > 2) || (isMd && logos?.length > 4);
    return (
        <section className="my-xxxl flex">
            {!!logos?.length && (
                <Marquee
                    autoFill={play}
                    pauseOnHover
                    speed={30}
                    play={play}
                    className={cls(
                        'py-xxs',
                        !play &&
                            '[&>*:nth-child(1)]:justify-center [&>*:nth-child(1)]:!animation-none [&>*:nth-child(2)]:hidden',
                    )}>
                    {logos.map((logo, i) => (
                        <div
                            key={`logo-${i}`}
                            className="mr-gutter flex justify-center px-lg lg:grayscale lg:opacity-30 hover:lg:opacity-100 hover:lg:grayscale-0 transition duration-200 ease-in-out">
                            <img
                                alt="Logo"
                                className="h-24 md:h-32 xl:h-[42px] w-auto max-w-[240px] object-contain object-center"
                                src={logo}
                            />
                        </div>
                    ))}
                </Marquee>
            )}
        </section>
    );
}
